export var TypeActionQuestInfo;
(function (TypeActionQuestInfo) {
    TypeActionQuestInfo["Received"] = "QuestInfo > Received";
    TypeActionQuestInfo["Request"] = "QuestInfo > Request";
    TypeActionQuestInfo["Finish"] = "QuestInfo > Finish";
    TypeActionQuestInfo["Update"] = "QuestInfo > Update";
    TypeActionQuestInfo["AddNewQuestIds"] = "QuestInfo > AddNewQuestIds";
    TypeActionQuestInfo["Skip"] = "QuestInfo > Skip";
    TypeActionQuestInfo["Select"] = "QuestInfo > Select";
    TypeActionQuestInfo["AddQuest"] = "QuestInfo > AddQuest";
    TypeActionQuestInfo["RemoveQuest"] = "QuestInfo > RemoveQuest";
})(TypeActionQuestInfo || (TypeActionQuestInfo = {}));
export var actionQuestInfo = function (questInfo) { return ({
    questInfo: questInfo,
    type: TypeActionQuestInfo.Received,
}); };
export var actionQuestInfoAddNewQuestIds = function (newQuestIds) { return ({
    questIds: newQuestIds,
    type: TypeActionQuestInfo.AddNewQuestIds,
}); };
export var actionQuestInfoRequest = function () { return ({
    type: TypeActionQuestInfo.Request,
}); };
export var actionQuestInfoUpdate = function (props) { return ({
    questUpdate: props,
    type: TypeActionQuestInfo.Update,
}); };
export var actionQuestInfoFinish = function (questFinish, newQuestIds, showRewardPellets) {
    if (showRewardPellets === void 0) { showRewardPellets = true; }
    return ({
        questFinish: questFinish,
        questIds: newQuestIds,
        showRewardPellets: showRewardPellets,
        type: TypeActionQuestInfo.Finish,
    });
};
export var actionQuestInfoTaskSkip = function (quests) { return ({
    quests: quests,
    type: TypeActionQuestInfo.Skip,
}); };
export var actionQuestInfoSelect = function (selectedQuest) { return ({
    selectedQuest: selectedQuest,
    type: TypeActionQuestInfo.Select,
}); };
export var actionQuestAddQuest = function (eventQuest) { return ({
    eventQuest: eventQuest,
    type: TypeActionQuestInfo.AddQuest,
}); };
export var actionQuestRemoveQuest = function (eventQuest) { return ({
    eventQuest: eventQuest,
    type: TypeActionQuestInfo.RemoveQuest,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/actionQuestInfo.ts
// module id = 126
// module chunks = 3